import React from 'react';

const UserSelfAccount = React.lazy(() => import('./UserSelfAccountDetails'));
const UserPasswordManagement = React.lazy(() => import('./UserPasswordManagement'));

export { UserSelfAccount, UserPasswordManagement };
